<template>
  <div class="refund-wrap">
    <div class="title">退款成功</div>
    <div class="refund-money">
      <div>
        <span class="left">退款余额</span>
        <span class="right">¥14000.00</span>
      </div>
      <div>
        <span class="left">退款账户</span>
        <span class="right">原支付账号</span>
      </div>
    </div>
    <div class="refund-flow">
      <div class="title">退款流程</div>
      <div class="flow-list">
        <div class="t2">呼呼打药审核通过</div>
        <div class="text">14000的退款已提交给微信/支付宝，请查看退款金额是否到 账。</div>
        <div class="time">2019-11-05 15:49:34</div>
        <div class="t2">发起订单退款申请</div>
        <div class="text">呼呼打药审核通过后将为您退款，请耐心等待</div>
        <div class="time">2019-11-05 15:49:34</div>
      </div>
    </div>
    <div class="refund-info">
      <div class="title">退款信息</div>
      <div class="info-box">
        <van-image
          class="img-box"
          src="https://img.yzcdn.cn/vant/leaf.jpg"
        ></van-image>
        <div class="mid">大南瓜作物</div>
        <div class="right">
          <p class="p1">¥20.00/亩</p>
          <p class="p2">×200亩</p>
          <p class="p3">合计：<span class="orange">¥4000.00</span></p>
        </div>
      </div>
      <div class="bp">
        <div class="item">
          <div class="t1">退款原因</div>
          <div class="t2">面积多了20亩</div>
        </div>
        <div class="item">
          <div class="t1">申请时间</div>
          <div class="t2">2019-03-01 11:11:02</div>
        </div>
        <div class="item">
          <div class="t1">订单编号 </div>
          <div class="t2">12345678987654321</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "refund",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>
<style lang="stylus" scoped>
.refund-wrap
  text-align left
  font-family Microsoft YaHei
  & > .title
    background #fff
    height 50px
    line-height 50px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    padding-left 12px
    color rgba(255, 153, 34, 1)
    border-bottom 1px solid #e5e5e5
  .refund-money
    margin-bottom 10px
    padding 12px
    background #fff
    & > div
      display flex
      justify-content space-between
      align-items center
      line-height 1.2
      margin-bottom 10px
      & > .left
        color #989898
        font-size 13px
      & > .right
        color #282828
        font-size 13px
  .refund-flow
    background #fff
    margin-bottom 10px
    .title
      font-size 14px
      color #282828
      height 40px
      line-height 40px
      padding-left 14px
      border-bottom 1px solid #e5e5e5
    .flow-list
      line-height 1.2
      padding 0 13px 13px
      .t2
        font-size 15px
        color #282828
        margin-bottom 10px
        margin-top 13px
      .text, .time
        color #989898
        font-size 13px
        line-height 22px
  .refund-info
    background #ffffff
    .title
      font-size 14px
      color #282828
      height 40px
      line-height 40px
      padding-left 14px
      border-bottom 1px solid #e5e5e5
    .info-box
      display flex
      align-items flex-start
      padding 10px 12px
      border-bottom 1px solid #e5e5e5
      .img-box
        width 62px
        height 62px
        margin-right 10px
        border-radius 5px
      .mid
        flex 1
        color #282828
        font-size 14px
      .right
        text-align right
        margin-left 20px
        line-height 1.2
        font-size 12px
        .p1
          color #282828
          margin-bottom 5px
        .p2
          color #999999
          margin-bottom 10px
        .p3
          color #282828
          & > span
            color #FF9922
    .bp
      padding 15px 0
      .item
        display flex
        margin-bottom 10px
        line-height 1.2
        &:last-child
          margin-bottom 0
        .t1
          width 89px
          color #666666
          font-size 13px
          padding-left 12px
        .t2
          color #282828
          font-size 13px
          flex 1
</style>